var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sk-navigation-link__icon-wrapper', {'active': _vm.isActive}]},[_c('img',{staticClass:"sk-navigation-link__icon",attrs:{"src":("/static/svg/" + _vm.icon),"title":_vm.title,"alt":_vm.title},on:{"click":_vm.actionGoTo}}),_vm._v(" "),(_vm.count > 0)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7fccfdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/NavigationLinkIcon.vue
// module id = null
// module chunks = 